import { InstanceLink } from '~/components/Details/InstanceDetails/MenuInstances';
import { ObjectLiteral } from '~/types/generics';

import {
  IProcessTypes,
  IProcess,
  IProcessesInstance,
  IProcessFile,
  IProcessXmlFormFieldParsed,
  IProcessCountByStatus,
  IPaginateValues,
  IProcessInstanceObjectType,
  IProcessDetails,
} from './types';

export function getProcessesRequest() {
  return {
    type: IProcessTypes.GET_PROCESSES_REQUEST,
  };
}
export function getProcessesSuccess(processes: IProcess[]) {
  return {
    type: IProcessTypes.GET_PROCESSES_SUCCESS,
    payload: { processes },
  };
}
export function getProcessesFailure() {
  return {
    type: IProcessTypes.GET_PROCESSES_FAILURE,
  };
}

export function getProcessRequest(key: string, tenantId: string) {
  return {
    type: IProcessTypes.GET_PROCESS_REQUEST,
    payload: { key, tenantId },
  };
}
export function getProcessSuccess(process: IProcess) {
  return {
    type: IProcessTypes.GET_PROCESS_SUCCESS,
    payload: { process },
  };
}
export function getProcessFailure() {
  return {
    type: IProcessTypes.GET_PROCESS_FAILURE,
  };
}

export function getAvailableAndFavoriteProcessesRequest(personId: number) {
  return {
    type: IProcessTypes.GET_AVAILABLE_AND_FAVORITE_PROCESSES_REQUEST,
    payload: { personId },
  };
}

export function getAvailableAndFavoriteProcessesSuccess(
  availableProcesses: IProcess[],
  favoriteProcesses: IProcess[],
) {
  return {
    type: IProcessTypes.GET_AVAILABLE_AND_FAVORITE_PROCESSES_SUCCESS,
    payload: { availableProcesses, favoriteProcesses },
  };
}

export function getAvailableAndFavoriteProcessesFailure() {
  return {
    type: IProcessTypes.GET_AVAILABLE_AND_FAVORITE_PROCESSES_FAILURE,
  };
}

export function createFavoriteProcessRequest(
  personId: number,
  processDefinitionKey: string,
  orgId: any,
) {
  return {
    type: IProcessTypes.CREATE_FAVORITE_PROCESS_REQUEST,
    payload: { personId, processDefinitionKey, orgId },
  };
}

export function createFavoriteProcessSuccess() {
  return {
    type: IProcessTypes.CREATE_FAVORITE_PROCESS_SUCCESS,
  };
}

export function createFavoriteProcessFailure(processDefinitionKey: string) {
  return {
    type: IProcessTypes.CREATE_FAVORITE_PROCESS_FAILURE,
    payload: { processDefinitionKey },
  };
}

export function deleteFavoriteProcessRequest(
  personId: number,
  processDefinitionKey: string,
) {
  return {
    type: IProcessTypes.DELETE_FAVORITE_PROCESS_REQUEST,
    payload: { personId, processDefinitionKey },
  };
}

export function deleteFavoriteProcessSuccess() {
  return {
    type: IProcessTypes.DELETE_FAVORITE_PROCESS_SUCCESS,
  };
}

export function deleteFavoriteProcessFailure(processDefinitionKey: string) {
  return {
    type: IProcessTypes.DELETE_FAVORITE_PROCESS_FAILURE,
    payload: { processDefinitionKey },
  };
}

export function getProcessesCountByStatusRequest(params: IPaginateValues) {
  return {
    type: IProcessTypes.GET_PROCESSES_COUNT_BY_STATUS_REQUEST,
    payload: { params },
  };
}

export function getProcessesCountByStatusSuccess(
  processesCountByStatus: IProcessCountByStatus[],
  total: number,
) {
  return {
    type: IProcessTypes.GET_PROCESSES_COUNT_BY_STATUS_SUCCESS,
    payload: { processesCountByStatus, total },
  };
}
export function getProcessesCountByStatusFailure() {
  return {
    type: IProcessTypes.GET_PROCESSES_COUNT_BY_STATUS_FAILURE,
  };
}

export function getProcessesSolicitationsRequest(params: ObjectLiteral) {
  return {
    type: IProcessTypes.GET_PROCESSES_SOLICITATIONS_REQUEST,
    payload: { params },
  };
}
export function getProcessesSolicitationsSuccess(
  processesSolicitations: IProcessesInstance[],
  processesType: 'inProgress' | 'completed' | 'deleted',
  total: string,
) {
  return {
    type: IProcessTypes.GET_PROCESSES_SOLICITATIONS_SUCCESS,
    payload: {
      processesSolicitations,
      processesType,
      total,
    },
  };
}
export function getProcessesSolicitationsFailure() {
  return {
    type: IProcessTypes.GET_PROCESSES_SOLICITATIONS_FAILURE,
  };
}

export function getProcessesSolicitationsCountRequest(params: ObjectLiteral) {
  return {
    type: IProcessTypes.GET_PROCESSES_SOLICITATIONS_COUNT_REQUEST,
    payload: { params },
  };
}
export function getProcessesSolicitationsCountSuccess(
  totalInProgress: string,
  totalCompleted: string,
  totalTerminated: string,
) {
  return {
    type: IProcessTypes.GET_PROCESSES_SOLICITATIONS_COUNT_SUCCESS,
    payload: {
      totalInProgress,
      totalCompleted,
      totalTerminated,
    },
  };
}
export function getProcessesSolicitationsCountFailure() {
  return {
    type: IProcessTypes.GET_PROCESSES_SOLICITATIONS_COUNT_FAILURE,
  };
}

export function getProcessesExecutionsRequest(params: ObjectLiteral) {
  return {
    type: IProcessTypes.GET_PROCESSES_EXECUTIONS_REQUEST,
    payload: { params },
  };
}
export function getProcessesExecutionsSuccess(
  processesExecutions: IProcessesInstance[],
  processesType: 'inProgress' | 'completed' | 'deleted',
  total: string,
) {
  return {
    type: IProcessTypes.GET_PROCESSES_EXECUTIONS_SUCCESS,
    payload: {
      processesExecutions,
      processesType,
      total,
    },
  };
}
export function getProcessesExecutionsFailure() {
  return {
    type: IProcessTypes.GET_PROCESSES_EXECUTIONS_FAILURE,
  };
}

export function getProcessesExecutionsCountRequest(params: ObjectLiteral) {
  return {
    type: IProcessTypes.GET_PROCESSES_EXECUTIONS_COUNT_REQUEST,
    payload: { params },
  };
}
export function getProcessesExecutionsCountSuccess(
  processesExecutionsInProgressTotal: string,
  processesExecutionsCompletedTotal: string,
  processesExecutionsTerminatedTotal: string,
  processesExecutionsTotal: number,
) {
  return {
    type: IProcessTypes.GET_PROCESSES_EXECUTIONS_COUNT_SUCCESS,
    payload: {
      processesExecutionsInProgressTotal,
      processesExecutionsCompletedTotal,
      processesExecutionsTerminatedTotal,
      processesExecutionsTotal,
    },
  };
}
export function getProcessesExecutionsCountFailure() {
  return {
    type: IProcessTypes.GET_PROCESSES_EXECUTIONS_COUNT_FAILURE,
  };
}

export function getProcessInstanceRequest(
  id: string,
  objectType: IProcessInstanceObjectType,
) {
  return {
    type: IProcessTypes.GET_PROCESS_INSTANCE_REQUEST,
    payload: { id, objectType },
  };
}
export function getProcessInstanceSuccess(
  processInstance: IProcessesInstance,
  objectType: IProcessInstanceObjectType,
) {
  return {
    type: IProcessTypes.GET_PROCESS_INSTANCE_SUCCESS,
    payload: { processInstance, objectType },
  };
}
export function getProcessInstanceFailure(
  objectType: IProcessInstanceObjectType,
) {
  return {
    type: IProcessTypes.GET_PROCESS_INSTANCE_FAILURE,
    payload: {
      objectType,
    },
  };
}

export function instantiateProcessRequest(
  process: IProcess,
  variables: { [key: string]: any },
  processFiles: IProcessFile[],
) {
  return {
    type: IProcessTypes.INSTANTIATE_PROCESS_REQUEST,
    payload: { process, variables, processFiles },
  };
}
export function instantiateProcessSuccess() {
  return {
    type: IProcessTypes.INSTANTIATE_PROCESS_SUCCESS,
  };
}
export function instantiateProcessFailure() {
  return {
    type: IProcessTypes.INSTANTIATE_PROCESS_FAILURE,
  };
}

export function getProcessXMLRequest(key: string, tenant_id: string) {
  return {
    type: IProcessTypes.GET_PROCESS_XML_REQUEST,
    payload: { key, tenant_id },
  };
}
export function getProcessXMLSuccess(process: IProcess) {
  return {
    type: IProcessTypes.GET_PROCESS_XML_SUCCESS,
    payload: { process },
  };
}
export function getProcessXMLFailure() {
  return {
    type: IProcessTypes.GET_PROCESS_XML_FAILURE,
  };
}

export function getProcessFormRequest(process: IProcess) {
  return {
    type: IProcessTypes.GET_PROCESS_FORM_REQUEST,
    payload: { process },
  };
}
export function getProcessFormSuccess(
  process_id: string,
  form: IProcessXmlFormFieldParsed[],
) {
  return {
    type: IProcessTypes.GET_PROCESS_FORM_SUCCESS,
    payload: { process_id, form },
  };
}
export function getProcessFormFailure(process_id: string) {
  return {
    type: IProcessTypes.GET_PROCESS_FORM_FAILURE,
    payload: { process_id },
  };
}

export function cancelProcessSolicitationsRequest(
  processInstanceId: string,
  processDetails: IProcessDetails,
  data: ObjectLiteral,
) {
  return {
    type: IProcessTypes.CANCEL_PROCESS_SOLICITATIONS_REQUEST,
    payload: { processInstanceId, processDetails, data },
  };
}
export function cancelProcessSolicitationsSuccess(processInstanceId: string) {
  return {
    type: IProcessTypes.CANCEL_PROCESS_SOLICITATIONS_SUCCESS,
    payload: { processInstanceId },
  };
}
export function cancelProcessSolicitationsFailure() {
  return {
    type: IProcessTypes.CANCEL_PROCESS_SOLICITATIONS_FAILURE,
  };
}

export function cancelProcessExecutionsRequest(
  processInstanceId: string,
  data: ObjectLiteral,
) {
  return {
    type: IProcessTypes.CANCEL_PROCESS_EXECUTIONS_REQUEST,
    payload: { processInstanceId, data },
  };
}
export function cancelProcessExecutionsSuccess(processInstanceId: string) {
  return {
    type: IProcessTypes.CANCEL_PROCESS_EXECUTIONS_SUCCESS,
    payload: { processInstanceId },
  };
}
export function cancelProcessExecutionsFailure() {
  return {
    type: IProcessTypes.CANCEL_PROCESS_EXECUTIONS_FAILURE,
  };
}

export function getExecutionListBySolicitationRequest(id: string) {
  return {
    type: IProcessTypes.GET_EXECUTION_LIST_BY_SOLICITATION_REQUEST,
    payload: { id },
  };
}

export function getExecutionListBySolicitationSuccess(
  executions: Array<InstanceLink>,
) {
  return {
    type: IProcessTypes.GET_EXECUTION_LIST_BY_SOLICITATION_SUCCESS,
    payload: { executions },
  };
}

export function getExecutionListBySolicitationFailure() {
  return {
    type: IProcessTypes.GET_EXECUTION_LIST_BY_SOLICITATION_FAILURE,
  };
}
